<template>
    <div class="chart-skeleton" :style="skeletonStyle"></div>
</template>

<script>
export default {
    name: "ChartSkeleton",
    props: {
        aspectRatio: { type: String, default: null },
        height: { type: String, default: null },
        width: { type: String, default: "100%" },
    },
    computed: {
        skeletonStyle() {
            const style = { width: this.width };
            if (this.height) style.height = this.height;
            if (this.aspectRatio) style.aspectRatio = this.aspectRatio;
            return style;
        },
    },
};
</script>

<style scoped>
.chart-skeleton {
    margin: 0 auto;
}
</style>
